import { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'

import routes from '../../routers'
import Layout from '../../components/Layout'
import { PdfUpsell } from '../../components/CookbookPromo'
import { cookbookError, cookbookFileUrl, getCookbookExport } from '../../api/cookbook'

import '../PurchaseBook/styles.css'
import styles from './CookbookPdf.module.css'

// Download a cookbook as a PDF: the same file the printer gets, for Pro. The free plan sees
// what's included and an upgrade prompt (never a watermarked file).
const CookbookPdf = () => {
  const { orderId } = useParams()
  const [info, setInfo] = useState(null)
  const [error, setError] = useState('')

  useEffect(() => {
    getCookbookExport(orderId)
      .then(({ data }) => setInfo(data))
      .catch((e) => setError(cookbookError(e, 'We could not find this cookbook.')))
  }, [orderId])

  let body
  if (error) body = <p className="cbError">{error}</p>
  else if (!info) body = <p className="cbMuted">Loading…</p>
  else if (!info.ready) {
    body = (
      <section className="cbSection">
        <h2 className="cbSectionTitle">Preview your book first</h2>
        <p className="cbHint">We build the PDF when you flip through the preview.</p>
        <Link className="cbNextButton" to={routes.purchaseBook}>
          Open the cookbook
        </Link>
      </section>
    )
  } else if (info.locked) {
    body = (
      <section className={`cbSection ${styles.pro}`}>
        <span className={styles.badge}>Pro</span>
        <h2 className="cbSectionTitle">Download your cookbook as a PDF with Pro</h2>
        <p className="cbHint">
          The whole book, {info.page_count} pages, exactly as it prints: to keep, share with the
          family, or print at home. Pro also unlocks unlimited recipes.
        </p>
        <Link className="cbNextButton" to={`${routes.settings}#subscription`}>
          Upgrade to Pro
        </Link>
        <p className="cbMuted">Cancel any time.</p>
      </section>
    )
  } else {
    body = (
      <section className="cbSection">
        <h2 className="cbSectionTitle">{info.title || 'Your cookbook'}</h2>
        <p className="cbHint">{info.page_count} pages, exactly as they print. No watermark.</p>
        <div className={styles.buttons}>
          <a className="cbNextButton" href={cookbookFileUrl(info.interior)}>
            Download the book (PDF)
          </a>
          <a className="cbSecondaryButton" href={cookbookFileUrl(info.cover)}>
            Download the cover (PDF)
          </a>
        </div>
      </section>
    )
  }

  return (
    <Layout title="Download as a PDF">
      <div className={`cbPage ${styles.page}`}>
        <div className="cbIntro">
          <h1 className="cbTitle">Download as a PDF</h1>
        </div>
        {body}
        {info?.ready ? <PdfUpsell /> : null}
      </div>
    </Layout>
  )
}

export default CookbookPdf
